import {
  CAMPAIGN_ERROR,
  CAMPAIGN_LOADING,
  SET_CAMPAIGNS,
  CAMPAIGN_DATABASE_UPDATING,
  CAMPAIGN_DATABASE_UPDATE,
  CAMPAIGN_DATABASE_UPDATE_ERROR,
} from "../constants";

const initial_state = {
  loading: {
    campaign: false,
    saving: false,
  },

  errors: {
    // campaign: "Error message"
  },
  nonExpandableKeys: [],
  expandableKeys: [],
  // Users
  list: [], // List of available campaigns
  listHistory: [], //list for history
  isInternalUser: false,
  selectedOptions: {
    type: "",
    subType: "",
    companyCode: "",
  },
};

export default function (state = initial_state, { type, payload }) {
  const loading = state.loading;

  switch (type) {
    case CAMPAIGN_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case CAMPAIGN_DATABASE_UPDATE_ERROR:
      loading.saving = false;
      return {
        ...state,
        loading: { ...loading },
        errors: payload || { unknown: "Unknown error" },
      };

    case CAMPAIGN_DATABASE_UPDATING:
      loading.saving = true;
      return {
        ...state,
        loading: { ...loading },
      };

    case CAMPAIGN_DATABASE_UPDATE:
      loading.saving = false;
      return {
        ...state,
        loading: { ...loading },
      };

    case CAMPAIGN_LOADING:
      loading.campaign = true;
      return {
        ...state,
        loading: { ...loading },
      };

    case SET_CAMPAIGNS:
      let nonExpandableKeys = (payload || [])
        .filter((item) => item.callWinEditable !== 1)
        .map((item) => item.id);

      let expandableKeys = (payload || [])
        .filter((item) => item.callWinEditable === 1)
        .map((item) => item.id);

      return {
        ...state,
        loading: { ...loading, campaign: false },
        nonExpandableKeys,
        expandableKeys,
        list: payload,
      };

    default:
      return state;
  }
}
